import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { projects } from "./constants/Projects";
import Project from "./Project";

function HorizontalScrollSections() {
  const sectionRef = useRef(null);
  const triggerRef = useRef(null);
  useEffect(() => {
    console.log(projects);
  }, []);
  gsap.registerPlugin(ScrollTrigger);
  useEffect(() => {
    const pin = gsap.fromTo(
      sectionRef.current,
      {
        translateX: 0,
      },
      {
        translateX: "-400vw",
        ease: "none",
        duration: 1,
        scrollTrigger: {
          trigger: triggerRef.current,
          start: "top top",
          end: "3000 top",
          scrub: 0.6,
          pin: true,
        },
      }
    );
    return () => {
      pin.kill();
    };
  }, []);
  return (
    <section className="scroll-section-outer ">
      <h2 className="text-[48px] max-sm:text-[30px] font-bold text-yellow mb-14 text-center">
        My Projects
      </h2>
      <div ref={triggerRef}>
        <div ref={sectionRef} className="scroll-section-inner ">
          {projects.map((prj) => (
            <Project key={prj.name} project={prj} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HorizontalScrollSections;
